/** CADRUL MACHETEI.
 *
 *  Documentul, după `northUp`, e +x est, +y SUD, +z sus: un cadru STÂNG. three.js
 *  desenează în cadru drept, așa că o scenă pusă direct în coordonatele lui iese
 *  în oglindă: privită de sus cu nordul sus, are estul la stânga, iar un corp în L
 *  își întoarce brațul.
 *
 *  Scena se pune într-un grup `lume` întors pe y (`lumeDreapta`). Tot ce se
 *  calculează rămâne în cadrul documentului: geometria, soarele, ținta camerei,
 *  fețele. La graniță se întoarce y o singură dată:
 *
 *  * ce intră în lume din afara grupului (camera, ținta ei, direcția soarelui
 *    din cer, planele de tăiere, care three le ia în coordonatele lumii):
 *    `inLume`, `planInLume`;
 *  * ce iese din lume spre calcul (raza cursorului, poziția camerei):
 *    `razaInDocument`, `inDocument`.
 *
 *  Loviturile se caută cu grupul pus drept (`inCadrulDocumentului`), cu raza
 *  dusă în cadrul documentului. Așa punctele lovite vin direct în coordonatele în
 *  care lucrează selecția (fețele, zonele, cotele), fără o a doua întoarcere pe
 *  fiecare drum.
 */
import * as THREE from "three";

/** Grupul în care stă tot conținutul scenei, întors pe y. */
export function lumeDreapta(): THREE.Group {
  const lume = new THREE.Group();
  lume.name = "lume";
  lume.scale.y = -1;
  return lume;
}

/** Un punct sau o direcție, din cadrul documentului în cel al lumii (pe loc). */
export function inLume<T extends THREE.Vector3>(v: T): T {
  v.y = -v.y;
  return v;
}

/** Din cadrul lumii în cel al documentului: aceeași întoarcere, pe o copie. */
export function inDocument(v: THREE.Vector3): THREE.Vector3 {
  return new THREE.Vector3(v.x, -v.y, v.z);
}

/** Raza cursorului (în lume, din cameră) dusă în cadrul documentului (pe loc). */
export function razaInDocument(r: THREE.Ray): THREE.Ray {
  r.origin.y = -r.origin.y;
  r.direction.y = -r.direction.y;
  return r;
}

/** Un plan de tăiere scris în cadrul documentului, în cel al lumii (pe loc).
 *  `n·p + c = 0` cu `p = M·q` devine `(M·n)·p + c = 0`: constanta rămâne. */
export function planInLume(p: THREE.Plane): THREE.Plane {
  p.normal.y = -p.normal.y;
  return p;
}

/** `fn` cu grupul pus drept: loviturile unei raze din `razaInDocument` cad în
 *  coordonatele documentului. */
export function inCadrulDocumentului<T>(lume: THREE.Object3D, fn: () => T): T {
  lume.scale.y = 1;
  lume.updateMatrixWorld(true);
  try {
    return fn();
  } finally {
    lume.scale.y = -1;
    lume.updateMatrixWorld(true);
  }
}
